import React, { Component } from 'react';

import submissionRequestHandler from '../../../components/contribution-form/submissionRequestHandler';
import {
  validateFields,
  getValidationMessage,
} from '../../../components/contribution-form/formValidator';

import InputStage from './input-stage';
import SubmittingStage from './submitting-stage';
import SubmissionFailedStage from './submission-failed-stage';
import SubmissionSuccessfulStage from './submission-successful-stage';

const fields = ['emailValue', 'messageValue'];

const a = (action, label) =>
  ga('send', {
    hitType: 'event',
    eventCategory: 'ContactForm',
    eventAction: action,
    eventLabel: label,
  });

export default class ContactForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailValue: '',
      messageValue: '',

      formValid: false,
      formValidationMessage: getValidationMessage(fields, {}),

      submitting: false,
      submitted: false,
      submissionSuccessful: null,
    };

    a('OpenForm');
  }

  onChange = (property, value) => {
    this.setState(() => ({ [property]: value }));
    this.setState(state => ({
      formValid: validateFields(fields, state),
      formValidationMessage: getValidationMessage(fields, state),
    }));
  };

  submit = () => {
    a('SubmitForm');
    const { emailValue, messageValue } = this.state;

    this.setState({
      submitting: true,
    });

    submissionRequestHandler('contact', null, {
      fields: {
        itemId: '__CONTACT_US_FORM__',
        email: emailValue,
        info: messageValue,
      },
    }).then(result => {
      if (result === true) {
        a('SubmissionSuccessful');
      } else {
        a('SubmissionFailed');
      }

      this.setState({
        submitting: false,
        submitted: true,
        submissionSuccessful: result === true,
      });
    });
  };

  backToForm = () => {
    a('BackToInput', this.props.form);
    this.setState({
      submitted: false,
      submissionSuccessful: null,
    });
  };

  render() {
    let Stage = InputStage;

    const {
      emailValue,
      messageValue,
      formValid,
      formValidationMessage,
      submitting,
      submitted,
      submissionSuccessful,
    } = this.state;

    if (submitting) {
      Stage = SubmittingStage;
    } else if (submitted && submissionSuccessful) {
      Stage = SubmissionSuccessfulStage;
    } else if (submitted && !submissionSuccessful) {
      Stage = SubmissionFailedStage;
    }

    return (
      <Stage
        emailValue={emailValue}
        messageValue={messageValue}
        onChange={this.onChange}
        formValid={formValid}
        formValidationMessage={formValidationMessage}
        submit={this.submit}
        backToForm={this.backToForm}
        submissionSuccessful={submissionSuccessful}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/contact-us/contact-form/index.js